module.exports = __webpack_public_path__ + "static/media/picture-(26).881b65e2.JPG";